/**
 * Hồ sơ khách "chung" cho tổ chức KHÔNG kết nối CRM riêng (backend trả `coCrm: false`):
 * chỉ dữ liệu trong hệ thống — không lịch bán hàng, đơn, điểm, ưu đãi, ghi chú CRM.
 */
import type { CustomerProfile } from '@/hooks/use-orders'

export const laHoSoChung = (p: CustomerProfile | null | undefined): boolean => p?.coCrm === false

/** SĐT trong hồ sơ là số khách tự nhắn, nhân viên chưa xác nhận (backend gắn cờ). */
export const laSdtChuaXacMinh = (p: CustomerProfile | null | undefined): boolean =>
  !!p?.phone?.trim() && p?.chatmql?.sdtChuaXacMinh === true

const GIAI_DOAN: Record<string, string> = {
  lead: 'Khách tiềm năng', subscriber: 'Đăng ký', mql: 'MQL', sql: 'SQL',
  opportunity: 'Cơ hội', customer: 'Khách hàng', evangelist: 'Khách trung thành', other: 'Khác',
}

export function truongHoSoChung(p: CustomerProfile): Array<{ label: string; value: string | null; full?: boolean; laSdt?: boolean }> {
  const c = p.chatmql
  const ngay = c?.firstSeenAt ? new Date(c.firstSeenAt) : null
  return [
    { label: 'Số điện thoại', value: p.phone || null, laSdt: true },
    { label: 'SĐT phụ (khách nhắn)', value: c?.soPhu?.length ? c.soPhu.join(', ') : null },
    { label: 'Email', value: c?.email ?? null },
    { label: 'Lead score', value: c ? `${c.leadScore ?? 0}/100` : null },
    { label: 'Giai đoạn', value: c?.lifecycleStage ? GIAI_DOAN[c.lifecycleStage] ?? c.lifecycleStage : null },
    { label: 'Liên hệ lần đầu', value: ngay && !Number.isNaN(ngay.getTime()) ? ngay.toLocaleDateString('vi-VN') : null },
    { label: 'Nguồn khách hàng', value: c?.source ?? null, full: true },
    { label: 'Địa chỉ', value: c?.address ?? null, full: true },
  ]
}
